import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import React, {useState} from 'react';
import Card from "@mui/material/Card";
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from "@mui/material/CardMedia";
import { makeStyles } from '@mui/styles';
import useSignedFileUrl from "../helpers/authenticatedFile";
const useStyles = makeStyles({
    root: {
        width: 200,
    },
    media: {
        height: 200,
        width: 200,
    },
});
const PictureWithLightBox = ({title,picture,className}) => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false)
    // Signed rather than fetched, so the browser can cache the image itself.
    const {url} = useSignedFileUrl(picture);

    if(!picture) return null

    return (
        <div>
           <Card className={classes.root}>
               <CardActionArea onClick={e => {
                   e.stopPropagation();
                   setIsOpen(true)
                  }}>
               <CardMedia
                   image={url}
                   title={title}
                   className={classes.media}
               />
               </CardActionArea>
           </Card>
            {isOpen && (
                <Lightbox
                    mainSrc={url}

                    onCloseRequest={() => setIsOpen(false)}

                />
            )}
        </div>
    );
};

export default PictureWithLightBox;